import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { httpCreateUser } from 'services/users';
import { USER_ROLE_LABELS } from './userRoleLabels';
import { useAuthContext } from 'contexts/AuthContext';
import './EditPumpModal.scss'; // Use same form styles

const roleMap = USER_ROLE_LABELS;

export default function AddUserModal({ isOpen, onClose, onSuccess }) {
  const { myUser, userRole } = useAuthContext();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    role: 4, // Default to regular user
    password: ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && userRole === 5) {
      setFormData((prev) => ({ ...prev, role: 5 }));
    }
    if (isOpen && userRole === 4) {
      setFormData((prev) => ({ ...prev, role: 4 }));
    }
    if (isOpen && userRole === 3) {
      setFormData((prev) => ({ ...prev, role: 3 }));
    }
  }, [isOpen, userRole]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);

    try {
      const resolvedRole =
        userRole === 5 ? 5 : userRole === 3 ? 3 : parseInt(formData.role, 10);

      const userData = {
        username: formData.email,
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        language: 'fi',
        role: resolvedRole,
        password: formData.password || undefined // Don't send empty password
      };

      const response = await httpCreateUser(userData);
      
      if (response?.status === 201 || response?.status === 200) {
        if (onSuccess) {
          onSuccess(response.data);
        }
        // Reset form
        setFormData({
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          role: userRole === 5 ? 5 : userRole === 4 ? 4 : userRole === 3 ? 3 : 4,
          password: ''
        });
        onClose();
      } else {
        setError('Luonti epäonnistui');
      }
    } catch (err) {
      console.error('Error creating user:', err);
      setError(err.response?.data?.message || 'Virhe käyttäjän luomisessa. Yritä uudelleen.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Lisää käyttäjä">
      <form className="edit-pump-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Etunimi</label>
          <input
            className="form-input"
            type="text"
            value={formData.first_name}
            onChange={(e) => handleInputChange('first_name', e.target.value)}
            placeholder="Matti"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Sukunimi</label>
          <input
            className="form-input"
            type="text"
            value={formData.last_name}
            onChange={(e) => handleInputChange('last_name', e.target.value)}
            placeholder="Meikäläinen"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Sähköposti</label>
          <input
            className="form-input"
            type="email"
            value={formData.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
            placeholder="matti.meikalainen@example.com"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Puhelin</label>
          <input
            className="form-input"
            type="text"
            value={formData.phone}
            onChange={(e) => handleInputChange('phone', e.target.value)}
            placeholder="040 123 4567"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Käyttäjäoikeus</label>
          <select
            className="form-select"
            value={formData.role}
            onChange={(e) => handleInputChange('role', e.target.value)}
            required
          >
            {Object.entries(roleMap)
              .filter(([id]) => {
                if (userRole === 2) return id !== '1';
                if (userRole === 5) return id === '5';
                if (userRole === 4) return ['4', '5'].includes(id);
                if (userRole === 3) return id === '3';
                return true;
              })
              .map(([id, name]) => (
              <option key={id} value={id}>{name}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Salasana (valinnainen)</label>
          <input
            className="form-input"
            type="password"
            value={formData.password}
            onChange={(e) => handleInputChange('password', e.target.value)}
            placeholder="Jätä tyhjäksi jos lähetetään kutsu"
          />
        </div>

        {error && <div className="form-error">{error}</div>}
        <button className="save-btn" type="submit" disabled={saving}>
          {saving ? 'Luodaan...' : 'Luo käyttäjä'}
        </button>
      </form>
    </Modal>
  );
}

